import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { TrustpilotWidget, TrustpilotWidgetTemplates, Wrapper } from "@cinch-nx/shared-ui";
import styles from "./customer-reviews.module.css";
import { Head, renderWithResolver } from "@cinch-nx/landing-ui-shared";
import { FullWidthCTA } from "@cinch-labs/design-system";
import { EventNames, TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
import { useRouter } from "next/router";
import { Intro } from "./components/intro";
import { useStoryblokState } from "@cinch-nx/data-storyblok";
import { CustomerReviewsSection } from "./components/customer-reviews-section/customer-reviews-section";
export function CustomerReviews(param) {
    var story = param.story, generatedAt = param.generatedAt, preview = param.preview;
    var content = useStoryblokState({
        story: story,
        enableBridge: preview
    }).content;
    var intro = content.intro, SEO = content.SEO, HowCinchWorksComponent = content.HowCinchWorksComponent, FaffFreeMotoringComponent = content.FaffFreeMotoringComponent, PreFooterCta = content.PreFooterCta;
    var IntroSection = intro[0];
    var SeoSection = SEO[0];
    var HowCinchWorksSection = HowCinchWorksComponent[0];
    var FaffFreeMotoringSection = FaffFreeMotoringComponent[0];
    var PreFooterSection = PreFooterCta[0];
    var contentIntroText = renderWithResolver(IntroSection.body);
    var router = useRouter();
    var trackEvent = useAnalytics().trackEvent;
    var handleClick = function() {
        trackEvent({
            eventName: "Customer Reviews -  click search all cars button",
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    name: EventNames.click,
                    category: "customer reviews page",
                    label: "button in page",
                    action: "view all cars"
                }
            }
        });
        router.push(PreFooterSection.CtaButton[0].url);
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Head, _object_spread_props(_object_spread({}, SeoSection), {
                generatedAt: generatedAt,
                fallbackTitle: "cinch reviews and customer testimonials",
                fallbackDescription: "Official cinch reviews from happy customers enjoying faff-free motoring. Don't just take our word for it - read cinch reviews now."
            })),
            /*#__PURE__*/ _jsxs("article", {
                className: styles.root,
                children: [
                    /*#__PURE__*/ _jsx(Wrapper, {
                        className: {
                            container: styles.teaserContainer
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ _jsx(Intro, {
                            introText: contentIntroText,
                            title: IntroSection.title
                        })
                    }),
                    /*#__PURE__*/ _jsx(Wrapper, {
                        className: {
                            container: styles.teaserContainer
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ _jsx(TrustpilotWidget, {
                            widget: TrustpilotWidgetTemplates.grid,
                            height: "500px"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.customerReviewsSectionContainer,
                        children: /*#__PURE__*/ _jsx(CustomerReviewsSection, {
                            howCinchWorks: HowCinchWorksSection,
                            faffFreeMotoring: FaffFreeMotoringSection
                        })
                    }),
                    /*#__PURE__*/ _jsx(FullWidthCTA, {
                        iconName: "search",
                        iconGradient: "galaxy",
                        iconSize: 41,
                        title: PreFooterSection.title,
                        subtitle: PreFooterSection.subtitle,
                        buttonLabel: PreFooterSection.CtaButton[0].label,
                        onButtonClick: handleClick
                    })
                ]
            })
        ]
    });
}
export default CustomerReviews;
